export const DRAG_DROP_PORTAL_CLASS = 'drag-drop-portal';
